<template>
  <div></div>
</template>

<script>
import Storage from '../../utils/Storage'

export default {
  async created() {
    const { id_token, access_token } = this.$route.query
    Storage.setItem('@cognito:id_token', id_token)
    Storage.setItem('@cognito:access_token', access_token)
    this.$router.push({ name: 'Videos' })
  },
}
</script>

<style></style>
